/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { format } from "date-fns";
import { zonedTimeToUtc } from 'date-fns-tz'

import { Tooltip, Avatar, Typography, Button, CircularProgress, Divider, Table, TableContainer, TableBody, TableRow, TableCell, Paper, TableHead, ButtonGroup } from '@material-ui/core'
import { LayersClear, Assignment, AssignmentInd, CloudDownload, Edit, Add } from '@material-ui/icons'
import { Skeleton } from '@material-ui/lab'

import Actions from '../../fluid/Actions/ActionFactory'
import ReportEditor from './ReportEditor/ReportEditor'

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({

})

class DedupSummary extends Component {
    state = {
        getting_report_info : false,
        getting_report_info_error : false,
        report_exist : false,
        report_metadata : null,
        report_metadata_error : false,
        report_versions : null,
        report_versions_error : false,
        generating_report : false,
        generating_report_error : false,
        getting_metadata : false,
        metadata_error : false,
        starting_review : false,
        reviewing_version : null,
        open_editor : false
    }

    componentWillMount () {
        if (this.props.ic_data.operation_status.dedup_detection_status === "Completed") {
            this.setState({ ...this.state, report_exist: true, getting_report_info : true } , () => {
                Actions('http_request', {
                    url : '/sainapse/duplicate_detection/report/metadata',
                    method : 'get',
                    data : {},
                    params : {
                        ic_name : this.props.ic_data.name
                    }
                }).then(res => {
                    this.setState({
                        ...this.state, 
                        report_metadata : res.data.result.Result
                    }, () => {
                        Actions('http_request', {
                            url : '/sainapse/duplicate_detection/report/versions',
                            method : 'get',
                            data : {},
                            params : {
                                ic_name : this.props.ic_data.name
                            }
                        }).then(res => {
                            this.setState({
                                ...this.state, 
                                report_versions : res.data.result.Result, getting_report_info : false
                            }, () => console.log("Dedup Summary State : ", this.state))
                        }).catch(err => {
                            this.setState({...this.state, getting_report_info : false, report_versions : null, report_versions_error : true})
                        })
                    })
                }).catch(err => {
                    this.setState({...this.state, getting_report_info : false, report_metadata : null, report_metadata_error : true, report_versions : null})
                })
            })
        }
    }

    generateReport = (ic_data) => {
        this.setState({...this.state, generating_report : true}, () => {
            Actions('http_request', {
                url : '/sainapse/active_duplicate_detection',
                method : 'post',
                params : {
                    ic_name : ic_data.name
                },
                data : {}
            }).then(res => {
                this.setState({...this.state, generating_report : false, generating_report_error : false}, () => this.props.refresh())
                console.log("Generating Report Response : ", res.data)
            }).catch(err => {
                this.setState({...this.state, generating_report : false, generating_report_error : true})
            })
        })
    }

    renderReportMetadata = (ic_data) => {
        if (this.state.getting_report_info) {
            return (
                <TableContainer style = {{width : '40%', margin : '10px'}} component = {Paper}>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    <Typography variant = 'subtitle2'><Skeleton/></Typography>
                                </TableCell>
                                <TableCell>
                                    <Skeleton/>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography variant = 'subtitle2'><Typography variant = 'subtitle2'><Skeleton/></Typography></Typography>
                                </TableCell>
                                <TableCell>
                                    <Skeleton/>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography variant = 'subtitle2'><Typography variant = 'subtitle2'><Skeleton/></Typography></Typography>
                                </TableCell>
                                <TableCell>
                                    <Skeleton/>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            )  
        } else {
            if (this.state.report_metadata_error === false) {
                return (
                    <TableContainer style = {{width : '40%', margin : '10px'}} component = {Paper}>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant = 'subtitle2'>Number of records scanned</Typography>
                                    </TableCell>
                                    <TableCell>
                                        {this.state.report_metadata.total_count}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant = 'subtitle2'>Number of groups identified</Typography>
                                    </TableCell>
                                    <TableCell>
                                        {this.state.report_metadata.num_groups}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant = 'subtitle2'>Number of duplicate records identified</Typography>
                                    </TableCell>
                                    <TableCell>
                                        {this.state.report_metadata.duplicate_count}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                )
            } else {
                return (
                    <Typography variant = 'caption' color = 'secondary'>Unable to fetch report metadata.</Typography>
                )
            }
        }
    }

    renderReportVersions = (ic_data) => {
        if (this.state.getting_report_info) {
            return (
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Version</TableCell>
                                <TableCell>Source Version</TableCell>
                                <TableCell>Created on</TableCell>
                                <TableCell>Review Completed on</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Action</TableCell>
                                <TableCell>Download</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell><Skeleton/></TableCell>
                                <TableCell><Skeleton/></TableCell>
                                <TableCell><Skeleton/></TableCell>
                                <TableCell><Skeleton/></TableCell>
                                <TableCell><Skeleton/></TableCell>
                                <TableCell><Skeleton/></TableCell>
                                <TableCell><Skeleton/></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            )  
        } else {
            if (this.state.report_versions_error === false && this.state.report_metadata_error === false) {
                return (
                    <TableContainer component = {Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Version</TableCell>
                                    <TableCell>Source Version</TableCell>
                                    <TableCell>Created on</TableCell>
                                    <TableCell>Review Completed on</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Action</TableCell>
                                    <TableCell>Download</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.renderVersions()}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )
            } else {
                return (
                    <Typography variant = 'caption' color = 'secondary'>Unable to fetch report versions.</Typography>
                )
            }
        }
    }

    renderVersions = () => {
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        let sorted_versions = this.state.report_versions.sort((a,b) => b.version - a.version)
        let versions = sorted_versions.map(report => {
            return (
                <TableRow>
                    <TableCell>{report.version}</TableCell>
                    <TableCell>{report.source_version}</TableCell>
                    <TableCell>{format(zonedTimeToUtc(format(new Date(report.creation_time),'yyyy-MM-dd HH:mm:ss'), timezone), 'yyyy/MM/dd, HH:mm:ss')}</TableCell>
                    <TableCell>{report.completion_time !== null ? format(zonedTimeToUtc(format(new Date(report.completion_time),'yyyy-MM-dd HH:mm:ss'), timezone), 'yyyy/MM/dd, HH:mm:ss') : null}</TableCell>
                    <TableCell>{report.status}</TableCell>
                    <TableCell>{this.renderActions(report)}</TableCell>
                    <TableCell>
                        <ButtonGroup disabled = {report.status === 'Complete' ? false : true} size = 'small' variant="contained" color="primary">
                            <Button onClick = {() => this.downloadReport(report.version, 'html')}>HTML</Button>
                            <Button onClick = {() => this.downloadReport(report.version, 'csv')}>CSV</Button>
                            <Button onClick = {() => this.downloadReport(report.version, 'excel')}>Excel</Button>
                        </ButtonGroup>
                    </TableCell>
                </TableRow>
            )
        })

        return versions
    }

    currentlyInReview = () => {
        let pending_reports = this.state.report_versions.filter(report => report.status === 'Pending')
        let currently_in_review = pending_reports.length > 0 ? true : false
        return currently_in_review
    }

    renderActions = (report) => {
        return (
            <div>
                <Button
                    style = {{margin : '3px'}}
                    variant = 'contained'
                    color = 'primary'
                    size = 'small'
                    onClick = {() => this.reviewVersion(report)}
                    disabled = {report.status === "Complete" ? true : false}
                    startIcon = {<AssignmentInd fontSize = 'small'/>}
                >
                    Review
                </Button>
                <Button
                    style = {{margin : '3px'}}
                    variant = 'contained'
                    color = 'primary'
                    size = 'small'
                    onClick = {() => this.createVersion(report)}
                    disabled = {this.currentlyInReview()}
                    startIcon = {<Add fontSize = 'small'/>}
                >
                    New Version
                </Button>
            </div>
        )
    }

    createVersion = (report) => {
        this.setState({...this.state, starting_review : true }, () => {
            Actions('http_request', {
                url : '/sainapse/duplicate_detection/report/review/start',
                method : 'post',
                data : {},
                params : {
                    ic_name : this.props.ic_data.name,
                    version : report.version,
                    user_id : JSON.parse(localStorage.getItem('logged_in_user_info')).email
                }
            }).then(res => {
                this.setState({...this.state, starting_review : false }, () => this.props.refresh())
            })
        })
    }

    reviewVersion = (report) => {
        this.setState({ ...this.state, reviewing_version : report.version, open_editor : true })
    }

    closeEditor = () => {
        this.setState({...this.state, reviewing_version : null, open_editor : false, getting_report_info : true}, () => {
            Actions('http_request', {
                url : '/sainapse/duplicate_detection/report/versions',
                method : 'get',
                data : {},
                params : {
                    ic_name : this.props.ic_data.name
                }
            }).then(res => {
                this.setState({
                    ...this.state, 
                    report_versions : res.data.result.Result, getting_report_info : false
                }, () => console.log("Dedup Summary State : ", this.state))
            }).catch(err => {

            })
        })
    }

    downloadReport = (version, format) => {
        this.setState({...this.state,})
        Actions('http_request', {
            url : this.props.drl_url + "/drl/active_DD/report",
            method : '',
            data : {},
            params : {
                ic_name : this.props.ic_data.name,
                version : version,
                format : format
            }
        }).then(res => {
            console.log("DRL Response : ", res.data)
            Actions('http_request', {
                url : this.props.drl_url + "/" + res.data.file_link,
                method : 'get',
                responseType : 'blob'
            }).then(response => {
                console.log("Download Response : ", res)
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', res.data.file_link); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
        }).catch(err => {

        })
    }

    getTrainingStatus = () => {
        let training_status = this.props.ic_data.latest_stage_status.find(status_obj => status_obj.operation === 'Deduplicate' && status_obj.stage === 'Training').status
        return training_status
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', display : 'flex', flexDirection : 'column'}}>
                    <div style = {{width : '100%', height : '60px', backgroundColor : '#F0F0F0', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px'}}>
                        <div>
                            <Tooltip title = "Deduplicator">
                                <Avatar style = {{width : '35px', height : '35px', backgroundColor : '#FDD300'}}>
                                    <LayersClear style = {{color : '#000000'}}/>
                                </Avatar>
                            </Tooltip>
                        </div>
                        <div style = {{flexGrow : 1}}>
                            <Typography style = {{marginLeft : '10px', fontSize : '16px', fontWeight : '500'}} variant = 'h6'>{this.props.ic_data.name}</Typography>
                        </div>
                        <div style = {{display : 'flex', flexDirection : 'column', justifyContent : 'flex-end'}}>
                            <Tooltip title = "Identify Duplicates">
                                <Button 
                                    size = 'small' 
                                    variant = 'contained'
                                    color = 'primary'
                                    startIcon = {this.state.generating_report ? <CircularProgress style = {{color : '#FFFFFF'}} size = {20}/> : <Assignment fontSize = 'small'/>}
                                    onClick = {() => this.generateReport(this.props.ic_data)}
                                    disabled = {this.getTrainingStatus() !== 'Completed' ? true : false}
                                >
                                    Identify Duplicates
                                </Button>
                            </Tooltip>
                            {this.getTrainingStatus() !== 'Completed' ? <Typography style = {{display : 'block'}} variant = 'caption' color = 'textSecondary'>Training is not yet complete.</Typography> : <Typography style = {{display : 'block'}} variant = 'caption' color = 'textSecondary'>Will delete any existing reports and create a new report.</Typography>}
                        </div>
                    </div>
                    <div style = {{width : '100%', padding : '10px', flexGrow : 1, overflow : 'scroll', backgroundColor : '#FAFBFC'}}>
                        <div style = {{width : '100%', padding : '5px'}}>
                            <Typography style = {{marginBottom : '5px'}} variant = 'subtitle2' color ='primary'>Summary</Typography>
                            {this.props.ic_data.operation_status.dedup_detection_status === 'Completed' ? this.renderReportMetadata(this.props.ic_data) : this.props.ic_data.operation_status.dedup_detection_status === 'InProgress' ? <Typography color = 'textSecondary'>Identifying Duplicates... Please refresh to view the status.</Typography> : <Typography color = 'textSecondary'>Duplicates have not been identified. Please click Identify Duplicates.</Typography>}
                        </div>
                        <Divider/>
                        <div style = {{width : '100%', padding : '5px', backgroundColor : '#FAFBFC'}}>
                            <Typography style = {{marginBottom : '5px'}} variant = 'subtitle2' color ='primary'>Versions</Typography>
                            {this.props.ic_data.operation_status.dedup_detection_status === 'Completed' ? this.renderReportVersions(this.props.ic_data) : this.props.ic_data.operation_status.dedup_detection_status === 'InProgress' ? <Typography color = 'textSecondary'>Identifying Duplicates... Please refresh to view the status.</Typography> : <Typography color = 'textSecondary'>Duplicates have not been identified. Please click Identify Duplicates.</Typography>}
                        </div>
                    </div>
                </div>
                {this.state.reviewing_version !== null ? 
                    <ReportEditor 
                        ic_data = {this.props.ic_data}
                        ic_name = {this.props.ic_data.name} 
                        version = {this.state.reviewing_version} 
                        open = {this.state.open_editor} 
                        close_editor = {this.closeEditor}
                        metadata = {this.state.report_metadata}
                    />
                : null}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(DedupSummary);